import { ControlledDocApi } from '../../../api/ControlledDoc'
import ControlledDoc from '../../../components/HSEQ/ControlledDocuments/ControlledDoc'
import React from 'react'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useModalData from '../../../elements/Hooks/useModalData'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'

function ControlledDocCont() {
  const { list: cached, fetching, fetch } = useFetchList(() => ControlledDocApi.list())
  const { list, company, onChangeCompany } = useListCompanyFilter(cached, fetching)
  const {
    visible,
    modalType,
    object: controlledDoc,
    setObject: setControlledDoc,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
    isNew,
  } = useModalData(ControlledDocApi.create, ControlledDocApi.update, ControlledDocApi.remove, fetch)

  return (
    <ControlledDoc
      {...{
        list,
        fetching,
        visible,
        modalType,
        controlledDoc,
        setControlledDoc,
        submitting,
        submit,
        isNew,
        removing,
        remove,
        formRef,
        onShow,
        onCancel,
        update,
        company,
        onChangeCompany,
      }}
    />
  )
}

export default ControlledDocCont
